import { Mail, Phone, MapPin } from 'lucide-react';
import { TID } from '../lib/testIds';
import { BRAND } from '../lib/data';

export default function Footer() {
  return (
    <footer
      data-testid={TID.footerRoot}
      className="relative bg-emerald-deep text-[color:var(--gold-soft)]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-20 md:py-24">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="eyebrow text-gold-brand mb-5">Begin the Journey</div>
            <h3 className="font-serif text-3xl md:text-5xl leading-[1.1] text-white max-w-xl">
              The path to Karbala &mdash; <em className="italic text-[color:var(--gold-soft)]">held quietly,</em> from your first message to your last farewell.
            </h3>
            <a href="#inquiry" data-testid={TID.footerCta} className="btn-primary mt-10 bg-[color:var(--gold)] !text-emerald-deep hover:!bg-[color:var(--gold-soft)] border-[color:var(--gold)]">
              Start an Inquiry
            </a>
          </div>

          <div className="lg:col-span-5">
            <div className="eyebrow text-gold-brand mb-5">Reach Us</div>
            <ul className="space-y-4 font-light text-[color:var(--gold-soft)]/85">
              <li className="flex items-start gap-3"><MapPin size={16} strokeWidth={1.5} className="mt-1 text-gold-brand flex-shrink-0" /><span>{BRAND.address}</span></li>
              <li className="flex items-start gap-3"><Phone size={16} strokeWidth={1.5} className="mt-1 text-gold-brand flex-shrink-0" /><span>{BRAND.whatsappPretty}</span></li>
              <li className="flex items-start gap-3"><Mail size={16} strokeWidth={1.5} className="mt-1 text-gold-brand flex-shrink-0" /><span>{BRAND.email}</span></li>
            </ul>
          </div>
        </div>

        <div className="hairline mt-16" />

        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs tracking-[0.18em] uppercase text-[color:var(--gold-soft)]/60">
          <div>&copy; {new Date().getFullYear()} {BRAND.fullName} &middot; {BRAND.domain}</div>
          <div className="font-serif text-xl text-gold-brand normal-case tracking-normal italic">
            بسم الله الرحمن الرحيم
          </div>
        </div>
      </div>
    </footer>
  );
}
